import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NewsFeedItemContentBase } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-base';

@Component({
    selector: 'fi-news-feed-item-content-form',
    template: `
        <div class="NewsFeedContent">
            <div class="NewsFeedContentHeader">
                {{ 'form.feed_text1' | fiAppText }}
                <a
                    class="NewsFeedItemHeader BrandedColor"
                    [fiStateSref]="FiStateNames.Form.View"
                    [fiStateSrefParams]="{ id: newsItem.ObjectId }"
                    [textContent]="getPreferredContentLabelName(newsItem.Content.Names)"
                ></a>
            </div>

            <a
                class="NewsFeedItem-FormReadMore BrandedColor"
                [fiStateSref]="FiStateNames.Form.View"
                [fiStateSrefParams]="{ id: newsItem.ObjectId }"
            >
                {{ 'form.feed_text2' | fiAppText }}&nbsp;{{ getPreferredContentLabelName(newsItem.Content.Names) }}
            </a>
        </div>
    `,
    styleUrls: ['./news-feed-item-content-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemContentFormComponent extends NewsFeedItemContentBase {}
